import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceStageOfLymphedema extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - Stage of Lymphedema' />
                    <label className={styles.label}>Stage of Lymphedema</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field={'OOCIRLYMPHSTAGE0'}
                        label={'Stage 0 (Lymphagiopathy)'}
                        className={styles.checkbox_wide}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field={'OOCIRLYMPHSTAGE1'}
                        label={'Stage I (Reversible)'}
                        className={styles.checkbox_wide}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field={'OOCIRLYMPHSTAGE2'}
                        label={'Stage II (Spontaneously Irreversible)'}
                        className={styles.checkbox_wide}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field={'OOCIRLYMPHSTAGE3'}
                        label={'Stage III (Lymphostatic Elephantiasis)'}
                        className={styles.checkbox_wide}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRLYMPHSTAGE0 ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRLYMPHSTAGE1 ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRLYMPHSTAGE2 ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRLYMPHSTAGE3
            ? true : false
    };
}

const connectedObservationCircumferenceStageOfLymphedema = connect(mapStateToProps)(ObservationCircumferenceStageOfLymphedema);
export { connectedObservationCircumferenceStageOfLymphedema as ObservationCircumferenceStageOfLymphedema };


